var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculatorDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2272 9.78L15.0072 12L17.2272 14.22C17.5172 14.51 17.5172 14.99 17.2272 15.28C17.0772 15.43 16.8872 15.5 16.6972 15.5C16.5072 15.5 16.3172 15.43 16.1672 15.28L13.9472 13.06L11.7272 15.28C11.5772 15.43 11.3872 15.5 11.1972 15.5C11.0072 15.5 10.8172 15.43 10.6672 15.28C10.5277 15.1389 10.4495 14.9484 10.4495 14.75C10.4495 14.5516 10.5277 14.3611 10.6672 14.22L12.8872 12L10.6672 9.78C10.3772 9.49 10.3772 9.01 10.6672 8.72C10.9572 8.43 11.4372 8.43 11.7272 8.72L13.9472 10.94L16.1672 8.72C16.4572 8.43 16.9372 8.43 17.2272 8.72C17.5172 9.01 17.5172 9.49 17.2272 9.78ZM21.3172 7V17C21.3172 17.96 20.5372 18.75 19.5672 18.75H7.63719C7.02719 18.75 6.47719 18.44 6.15719 17.93L2.86719 12.66C2.61719 12.26 2.61719 11.74 2.86719 11.33L6.15719 6.07C6.47719 5.56 7.03719 5.25 7.63719 5.25H19.5772C20.5372 5.25 21.3272 6.04 21.3272 7H21.3172ZM19.8172 7C19.8172 6.86 19.7072 6.75 19.5672 6.75H7.63719C7.54719 6.75 7.46719 6.79 7.42719 6.87L4.21719 12L7.42719 17.13C7.47719 17.2 7.55719 17.25 7.63719 17.25H19.5772C19.7172 17.25 19.8272 17.14 19.8272 17V7H19.8172Z",
    fill: "#9C4F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorDeleteIcon);
export default __webpack_public_path__ + "static/media/calculator-delete-icon.4ceb7d88a3e2ba5d7d94f9cede035f63.svg";
export { ForwardRef as ReactComponent };